// import imageCompression from 'browser-image-compression'
import { uploadOverlayImage } from '~/ServerAPI'

// TODO: move to actions/images?
export const uploadOverlays = (assetBlobs, abortController) => async () => assetBlobs
  .map(assetBlob => uploadOverlayImage(assetBlob.blob, abortController)
    .then(response => response?.data)
    .then(data => ({ assetId: assetBlob.assetId, data }))
    .catch(err => {
      // Ignore AbortError to avoid breaking Promise.all
      if (err.message === 'canceled') {
        return null
      }
      return { error: new Error('failed upload image') }
    }))
